import { useNavigate, useParams } from 'react-router-dom'

import {
  CostCenterEmployeeListDocument,
  CostCentersPeopleDetailsPageDocument,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { CostCenterAssignmentsSidepanel } from 'modules/cost_centers/components/CostCenterAssigments/AssignmentsWithSidepanel'

const CostCentersPeopleDetailsPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { id } = useParams()

  const { data, loading } = useQuery(CostCentersPeopleDetailsPageDocument, {
    variables: {
      employeeId: Number(id),
    },
    skip: !id,
  })

  if (!id) return null

  return (
    <CostCenterAssignmentsSidepanel
      loading={loading}
      open
      resourceId={Number(id)}
      resourceType="Employee"
      title={i18n.t('finance.employee_dimensions_info.modals.set_assignments.assignment_title', {
        employeeName: data?.employees?.employee?.fullName,
      })}
      onSubmit={() => {
        navigate(navigation.settings.finance.costCenters.people.fullPath())
      }}
      onClose={() => {
        navigate(navigation.settings.finance.costCenters.people.fullPath())
      }}
      refetchQueries={[CostCenterEmployeeListDocument]}
    />
  )
}

export default CostCentersPeopleDetailsPage
